<div class="apm-card shadow flex-column mb-4 cursor-default">
  <ng-container #fieldComponent></ng-container>
</div>
